import { formatDate } from '@/utils'
export const dataResult = {
  fields: [
    {
      name: "策略类型",
      option_key: "csearch_strategy",
      placeholder: "策略类型",
      property: "csearch_strategy",
      required: "1",
      type: "select"
    },
    {
      name: "产品组别",
      parent_field: "csearch_strategy",
      property: "csearch_scale_group",
      required: "0",
      type: "select"
    },
    {
      name: "排名周期",
      option_key: "csearch_rank_range",
      property: "csearch_rank_range",
      required: "1",
      type: "select"
    },
    {
      name: "排名期",
      parent_field: "csearch_rank_range",
      property: "csearch_end_date",
      required: "0",
      type: "select"
    },
    {
      name: "关键字",
      placeholder: "基金名称/所属机构",
      property: "csearch_fund_name",
      required: "0",
      type: "text"
    }
  ],
  match_info: {
    competition_name: "申万宏源金玛杯实盘大赛",
    competition_status: "3"
  },
  option_definition: {
    csearch_rank_range: [
      {
        // children: [
        //   {
        //     label: "2021年06月", 
        //     value: "2021-06"
        //   },
        //   {
        //     label: "2021年07月", 
        //     value: "2021-07"
        //   },
        //   {
        //     label: "2021年08月", 
        //     value: "2021-08"
        //   }
        // ],
        children: getRankRange(),
        label: "月度榜单",
        value: "1m",
      },
      {
        label: "季度榜单", 
        value: "3m", 
        children: []
      },
      {
        label: "总榜单", 
        value: "race", 
        children: []
      },
    ],
    csearch_strategy: [
      {
        children: [
          {label: "大资产规模组(5000万元以上)", value: "2"},
          {label: "小资产规模组(500万-5000万元)", value: "1"}
        ],
        label: "权益组",
        value: "1"
      },
      {
        children: [
          {label: "大资产规模组(5000万元以上)", value: "2"},
          {label: "小资产规模组(500万-5000万元)", value: "1"}
        ],
        label: "相对价值&混合策略组",
        value: "2"
      },
      {
        children: [
          {label: "大资产规模组(2000万元以上)", value: "2"},
          {label: "小资产规模组(500万-2000万元)", value: "1"},
        ],
        label: "CTA组",
        value: "3"
      },
      {
        children: [],
        label: "期权组",
        value: "4"
      }
    ]
  }
}
// 自动计算月
function getRankRange() {
  // let curmon = date.getMonth() // 比当前月少一个月
  // let curyear = date.getFullYear() // 当前年
  let ln = 8 // 改长度就可
  let ranks = []
  for (let i = 0; i <= ln; i++) {
    let now = new Date()
    ranks.push({
      label: formatDate(new Date( now.setMonth(now.getMonth() - i)), 'YYYY年MM月'),
      value: formatDate(new Date( now.setMonth(now.getMonth() - i)), 'YYYY-MM'),
    })
    
  }
  return ranks
}